import { FormGroup } from '@angular/forms';
import { AbstractControl } from '@angular/forms';

export function currentDateFormat() {
    let today = new Date();
    let day = today.getDate();
    let mont = today.getMonth() + 1; //January is 0!
    let dd: string;
    let mm: string;
    var yyyy = today.getFullYear();
    if (day < 10) {
        dd = '0' + day;
    } else {
        dd = day.toString();
    }
    if (mont < 10) {
        mm = '0' + mont;
    } else {
        mm = mont.toString();
    }
    return yyyy + '-' + mm + '-' + dd;
}

export function dateFormateYYYYMMDD(id) {
    let today = new Date(id);
    let day = today.getDate();
    let mont = today.getMonth() + 1; //January is 0!
    let dd: string;
    let mm: string;
    var yyyy = today.getFullYear();
    if (day < 10) {
        dd = '0' + day;
    } else {
        dd = day.toString();
    }
    if (mont < 10) {
        mm = '0' + mont;
    } else {
        mm = mont.toString();
    }
    return yyyy + '-' + mm + '-' + dd;
}

export function minimumRequiredValues(numValues: Number, formGroup: FormGroup) {
    let formValue = { ...formGroup.value };
    for (let prop in formValue) {
        if (!formValue[prop]) {
            delete formValue[prop];
        }
        if (Array.isArray(formValue[prop])) {
            let resultArray = formValue[prop].filter(item => item);
            if (resultArray.length > 0) {
                formValue[prop] = resultArray;
            } else {
                delete formValue[prop];
            }
        }
    }
    if (Object.keys(formValue).length < numValues) {
        return true;
    }
}

export function PasswordComplexityValidator(control: AbstractControl) {
  const value = control.value || '';
  const hasUpperCase = /[A-Z]/.test(value);
  const hasLowerCase = /[a-z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);
  const isValidLength = value.length >= 8;

  const valid = hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && isValidLength;

  return valid ? null : {
    passwordComplexity: {
      requirements: 'Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.'
    }
  };
}

export function isPasswordValid(password: string) {
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const isValidLength = password.length >= 8;

    const valid = hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && isValidLength;
    return valid ? true : false;
}
